var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 170,
    viewBox: "0 0 500 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 43.1313C26.8201 47.5627 41.686 42.9988 63.9556 30.8973C78.9239 22.7707 91.5365 11.1844 109.373 7.66585C131.159 3.38173 153.663 12.6272 170.446 23.9485C187.243 35.2697 201.48 49.1526 221.203 57.3381C262.158 74.3421 314.598 61.5928 351.514 39.9366C367.477 30.5734 381.919 19.5907 399.302 11.8027C416.684 4.01478 438.31 -0.328244 457.258 5.03059C472.826 9.43249 484.283 19.6496 499.12 25.3029V169.079H0V43.1313Z",
    fill: "#183171"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.880371 77.2498C18.6317 59.8938 47.7991 48.8618 75.0345 54.1127C93.7769 57.7354 110.474 66.3187 127.611 73.6145C144.748 80.8977 163.603 87.108 182.734 85.3408C224.597 81.4657 250.955 41.9951 292.429 35.8101C336.55 29.2338 382.477 62.7086 423.625 47.9277C453.345 37.2617 468.085 4.50624 500 0V170H0.880371V77.2498Z",
    fill: "#4765B5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthWaves);
export default __webpack_public_path__ + "static/media/authWaves.a1afae493145262f43175bba96f772df.svg";
export { ForwardRef as ReactComponent };